import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

/**
 * Generated class for the DurationPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'duration',
})
export class DurationPipe implements PipeTransform {
    /**
     * Takes a value and makes it lowercase.
     */
    transform(mins: any, countItems: number) {
        if (mins === null || mins === undefined) { return }
        mins = parseInt(mins);
        countItems ? mins = mins * countItems : null;
        let now = moment();
        let exp = moment().add(mins, 'minutes');
        let diffDuration = moment.duration(exp.diff(now));
        let days = diffDuration.days();
        let hours = diffDuration.hours();
        let minutes = diffDuration.minutes();

        let time = '';

        if (days > 0) {
            time += days + ' day' + (days > 1 ? 's' : '');
        }

        if (hours > 0) {
            time += ' ' + hours + ' hr' + (hours > 1 ? 's' : '');
        }

        // If hours is greater than 0 then only show minutes if the minutes are greater than 0
        if (hours > 0 && minutes > 0) {
            time += ' ' + minutes + ' min' + (minutes > 1 ? 's' : '');
        }

        // show minutes always when hours is less than 1
        if (hours < 1 && minutes >= 0) {
          time += ' ' + minutes + ' min' + (minutes > 1 ? 's' : '');
        }

        return time;
    }
}



// WEBPACK FOOTER //
// ./src/pipes/duration/duration.ts